import React, { useEffect, useState, useRef } from 'react';
import { } from '../js/store';
import useAuth from "../hooks/auth";
import useAlerts from '../hooks/alerts';
import { useStore } from "../js/store";
import PropTypes from 'prop-types';
import ContactStatus from './contactStatus';
import Button from 's2s-button';
import { CaretDownIconSVG } from 's2s-svg-icons';
import { injectIntl } from 'react-intl';
import Avatar from 's2s-avatar';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import { getIntlText } from '../js/utilities';
import Select from 'react-select';
import ApplicationData from '../../package.json';
import AppService, { Utilities, track } from 's2s-app-service';

const ComposedButton = injectIntl(Button);
const ComposedContactStatus = injectIntl(ContactStatus);

const AppMenuContainer = styled.div`
  align-items : center;
  display: flex;
  background-color: transparent;
  margin-right: 8px;
`;

// NOTE: This is added to address accessibility issues. When AppMenu is closed, display will be 'none' and AppMenu sub components can no longer be tabbed through while unseen. - KCN
const AppMenuArea = styled.div`
  display : ${props => props.showAppMenu === true ? 'flex' : 'none'};
`;

const AppMenuDropdown = styled.div`
  background-color: ${colorGrid.gray0};
  border: 1px solid ${colorGrid.gray3};
  border-radius: 4px;
  box-shadow: 0px 4px 16px rgba(33, 37, 41, 0.16);
  display: flex;
  font-family : inherit;
  min-width: 224px;
  padding-bottom: 6px;
  padding-left: 0px;
  padding-right: 0px;
  position: absolute;
  right: 4px;
  word-break: break-word;
  z-index: 2;
`;

const CaretContainer = styled.div`
  height: 24px;
  width: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${props => props.showAppMenu ? "#182661" : "transparent"};
  :hover{
    background-color: #182661;
  };
`;

const AppMenuContent = styled.div`
  width: 100%;
`;

const UserInfoArea = styled.div`
  box-shadow: inset 0 -1px 0 0 ${colorGrid.gray3};
  background-color: ${colorGrid.gray0};
  color: ${colorGrid.gray9};
  display: flex;
  flex-direction: row;
  font-size: 16px;
  font-weight: 600;
  padding: 9px;
  z-index: 1;
`;

const NameExtensionArea = styled.div`
  color: #243991;
  font-family: Poppins;
  font-weight: 600;
  margin-left: 16px;
  width: 65%;
  z-index : 1;
`;

const Version = styled.div`
  border-bottom: 1px solid #e5e6e8;
  color: #7f888f;
  display: flex;
  font-family: Open Sans;
  font-size: 14px;
  padding: 14px 17px;
`;

const SettingsHelpButtonContainer = styled.div`
  align-items: flex-start;
  box-shadow: inset 0 -1px 0 0 ${colorGrid.gray3};
  display: flex;
  flex-direction: column;
  padding: 4px 0;
`;

const StyledMenuButton = styled(ComposedButton)`
  background-color: ${colorGrid.gray0};
  border-radius: 0px;
  color: #001221;
  font-family: Open Sans;
  height: 45px;
  width: 100%;

  :hover {
    background-color: rgba(36, 57, 145, 0.04);
  }
`;

const SignOutButton = styled(ComposedButton)`  
  background-color: ${colorGrid.gray0};
  border-radius: 0px;
  font-family: Open Sans;
  height: 40px;
  margin-top: 4px;
  width: 100%;
  
  div {
    color: #001221;
  }
  
  :hover {
    background-color: rgba(36, 57, 145, 0.04);
  }
`;

const StyledAvatar = styled(Avatar)`
  background-color: ${colorGrid.gray1};
  border: solid 1px ${colorGrid.gray4};
  border-radius: 50%;
  color: ${colorGrid.gray9};
  height: 40px;
  width: 40px;
`;

const AppMenu = (props) => {
  // not using data from Auth, so put nothing as first array element
  const [, { logout }] = useAuth();
  const [theStore] = useStore();
  const [isOpen, setAppMenuState] = useState(false);
  const [, { createErrorAlert }] = useAlerts();


  const auth = theStore && theStore.auth;

  useEffect(() => {
    document.addEventListener('click', closeUserMenu);

    return function cleanup() {
      document.removeEventListener('click', closeUserMenu);
    };
  });

  const doesNodeContainTarget = (target, node) => {
    // NOTE: Target is the dom node that was clicked, and node is a ref/dom node
    // NOTE: Checking to see if target exists inside node. It will return either true or false.
    return node !== null && node !== undefined && node.contains(target);
  };

  const closeUserMenu = (e) => {

    // NOTE: We are checking we are clicking away from UserMenu / or that UserMenu dropdown is being clicked (ContactStatus + Caret)''
    if (!doesNodeContainTarget(e.target, appMenuRef.current)) {
      setAppMenuState(false);
    }
  };

  // const handleStatusClick = () => {
  //   props.cbStatusClick(!props.showAppMenu);
  // }

  // const handleStatusKeyPress = (char) => {
  //   if(char.charCode == '13'){
  //     handleStatusClick();
  //   }
  // }

  const avatarObject = {
    email: auth && auth.auth && auth.auth.identity && auth.auth.identity.email && auth.auth.identity.email !== "" ? auth.auth.identity.email : undefined,
    firstname: auth && auth.auth && auth.auth.identity ? auth.auth.identity.first_name : undefined,
    lastname: auth && auth.auth && auth.auth.identity ? auth.auth.identity.last_name : undefined
  };

  // Putting extensions in a format that makes react-select happy
  let extensions = [];
  let selectedExtension = {};

  if (auth && auth.isAuthorized && typeof props.availableExtensions !== "undefined" && props.availableExtensions) {

    extensions = props.availableExtensions.map((ext) => {
      return {
        label: ext.extension,
        value: ext.extension
      };
    });

    const currentExtension = AppService.getInstance().getCallService().getCurrentExtension();
    //console.log('---------------------------', currentExtension, AppService.getInstance().getCallService().getAvailableExtensions(), AppService.getInstance().getCallService());
    const extension = typeof currentExtension === "undefined" ? undefined : currentExtension.extension;
    selectedExtension = {
      label: extension,
      value: extension
    };
  }

  const handleSettingsClick = () => {
    setAppMenuState(false);
    props.cbSettingsClick();
  };

  const handleHelpClick = () => {
    setAppMenuState(false);
    props.cbHelpClick();
  };

  const changeExtension = (newExt) => {
    track("extension", "changed", newExt);
    const fullExt = props.availableExtensions.reduce((acc, ext) => {
      if (!acc) {
        if (ext.extension === newExt.value) {
          return ext;
        }
      }
      return acc;
    }, undefined);

    // console.log('jjjjjjj', theStore, Object.keys(theStore.callInfo.inprogressCalls).length);
    if (Object.keys(theStore.callInfo.inprogressCalls).length === 0) {
      console.log('switching extensions ', fullExt, theStore.settings);
      AppService.getInstance().getCallService().s2sLogin(fullExt);
    } else {
      // objAlertItem is expected to look like this for proper rendering by alertList/alertItem

      createErrorAlert({
        message: Utilities.getInstance().getIntlMessage('CHANGE-EXTENSION-ERROR-HEADING', 'Error Changing Extension'),
        details: [Utilities.getInstance().getIntlMessage('CHANGE-EXTENSION-ERROR', 'Cannot change extensions since you have an active call')],
        autoCloseTimeout: 15,
      });
    }
  };

  // if selectedExtension not in props.extensions, set selected extension index to 0
  //const selExtensionIndex = extensions && extensions.indexOf(props.selectedExtension) !== -1 ? extensions.indexOf(props.selectedExtension) : 0;

  const appMenuRef = useRef(null);
  return (
    <div ref={appMenuRef}>
      <AppMenuContainer
        aria-label="open app menu"
        className="appMenuContainer"
        ref={appMenuRef}
        tabIndex={0}
      >
        <ComposedContactStatus
          status={props.status}
          iconPosition='left'
        />
        <CaretContainer
          showAppMenu={isOpen}
          tabIndex={0}
          onClick={() => {
            track("toggle_app_menu", "clicked");
            setAppMenuState(!isOpen);
          }}
        >
          <CaretDownIconSVG
            svgStyle={{
              fill: "#FFFFFF",
              height: 18,
              width: 18,
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
            }}
          />
        </CaretContainer>
      </AppMenuContainer>
      <AppMenuArea showAppMenu={isOpen}>
        <AppMenuDropdown className="AppMenuDropdown">
          <AppMenuContent className="AppMenuContent">
            <UserInfoArea>
              <StyledAvatar
                className={`${props.className} StyledAvatar`}
                entity={avatarObject}
              />
              <NameExtensionArea className="nameExtensionArea">
                {auth && auth.auth && auth.auth.identity ? auth.auth.identity.first_name + ' ' + auth.auth.identity.last_name : ""}
                <Select
                  value={selectedExtension}
                  onChange={changeExtension}
                  options={extensions}
                  styles={{
                    container: (style) => ({
                      ...style,
                      fontFamily: 'Open Sans',
                      fontSize: '14px',
                      fontWeight: 400,
                      marginTop: '3px',
                    }),
                    control: (style, state) => ({
                      ...style,
                      borderColor: state.menuIsOpen ? '#243991' : '#cccfd2',
                      borderRadius: '4px',
                      boxShadow: 'none',
                      height: '40px',
                      '&:hover': { cursor: 'pointer' },
                    }),
                    indicatorSeparator: () => ({ display: 'none' }),
                    menu: (style) => ({ ...style, borderRadius: '4px' }),
                    option: (style, { isSelected }) => ({
                      ...style,
                      backgroundColor: isSelected ? 'rgba(36, 57, 145, 0.08)' : colorGrid.gray0,
                      color: isSelected ? '#243991' : '#212121',
                      padding: '7px 12px',
                      ':hover': {
                        backgroundColor: isSelected ? 'rgba(36, 57, 145, 0.08)' : 'rgba(36, 57, 145, 0.04)',
                        cursor: 'pointer',
                      },
                    }),
                  }}
                />
              </NameExtensionArea>
            </UserInfoArea>
            <SettingsHelpButtonContainer className="settingsHelpButtonContainer" >
              <StyledMenuButton
                cbClick={handleSettingsClick}
                buttonLabel={getIntlText(props.intl, 'APPMENU-SETTINGS-BTN-LABEL', "Open Settings")}
                buttonType="secondary"
                svgFill="#4c5863"
                svgType="MdSettings"
              />
              <StyledMenuButton
                cbClick={handleHelpClick}
                buttonLabel={getIntlText(props.intl, 'APPMENU-HELP-BTN-LABEL', "Help documentation")}
                buttonType="secondary"
                svgFill="#4c5863"
                svgType="MdHelpOutline"
              />
            </SettingsHelpButtonContainer>
            <Version className="version">
              {`${getIntlText(props.intl, 'APPMENU-VERSION', 'App Version')} ${ApplicationData.version}`}
            </Version>
            <SignOutButton
              buttonLabel={getIntlText(props.intl, 'APPMENU-LOGOUT-BTN-LABEL', 'Sign Out')}
              cbClick={() => { track("logout", "clicked"); setAppMenuState(false); logout(props.intl); }}
            />
          </AppMenuContent>
        </AppMenuDropdown>
      </AppMenuArea>
    </div>
  );
};


AppMenu.propTypes = {
  availableExtensions: PropTypes.array,
  cbHelpClick: PropTypes.func, // passed in from Header
  cbSettingsClick: PropTypes.func, // passed in from Header
  cbStatusClick: PropTypes.func, // passed in from Header
  className: PropTypes.string,
  status: PropTypes.string,
  selExtensionIndex: PropTypes.string,
  intl: PropTypes.object,
};

AppMenu.defaultProps = {
  cbHelpClick: () => { console.log(" Please define a callback function for cbHelpClick in AppMenu"); },
  cbSettingsClick: () => { console.log(" Please define a callback function for cbSettingsClick in AppMenu"); },
  cbStatusClick: () => { console.log("please define a callback function for cbChangeExtension in AppMenu"); },
  status: "offline"
};

export default AppMenu;
